<div class="container-fluid sticky-header" *ngIf="isOtpAuthenticated">
    <div class="row">
        <div class="col-sm-12 col-lg-12 logoImg"> 
            <div class="container-fluid py-1"><img class="" src="../../assets/images/logo.svg" alt="" > </div>
        </div>
    </div>
</div>
<ng-container *ngIf="isOtpAuthenticated">
    <div class="py-3 paddingLogin">
        <div class="login pt-4">
            <div class="leftpart"><img class="mt-5" src="../../assets/images/login.png" alt="" ></div>
            <div class="rightpart">
                <form class="login-form registration-form" [formGroup]="registrationForm" *ngIf="registerFormLoaded">
                    <h1 class="title text-center">Registration</h1>
                    <div class="mb-4">
                        <img src="../../assets/images/user-avatar.png" alt="" >
                        <input type="text" class="form-control" id="firstname" placeholder="First Name" formControlName="firstname"
                        (keydown)="checkAlphabets($event)" (paste)="onPaste($event)" maxlength="100">
                        <div *ngIf="registrationForm.controls['firstname']!.invalid" class="errMsg">
                            <span *ngIf="(isSubmitted || registrationForm.controls['firstname']!.touched || registrationForm.controls['firstname']!.dirty) && 
                            (registrationForm.controls['firstname']!.errors && registrationForm.controls['firstname']!.errors!['required'])">This field is required</span>
                        </div>    
                    </div>
                    <div class="mb-4">
                        <img src="../../assets/images/user-avatar.png" alt="" >
                        <input type="text" class="form-control" id="lastname" placeholder="Last Name" formControlName="lastname"
                        (keydown)="checkAlphabets($event)" (paste)="onPaste($event)" maxlength="100">
                        <div *ngIf="registrationForm.controls['lastname']!.invalid" class="errMsg">
                            <span *ngIf="(isSubmitted || registrationForm.controls['lastname']!.touched || registrationForm.controls['lastname']!.dirty) && 
                            (registrationForm.controls['lastname']!.errors && registrationForm.controls['lastname'])!.errors!['required']">This field is required</span>
                        </div>    
                    </div>
                    <div class="mb-4 mobileDiv">
                        <div class="countrycode">
                            <span class="plusSign">+</span>
                            <input type="text" class="form-control" id="countrycode" placeholder="Country Code" 
                            formControlName="countrycode" maxlength="3" (keydown)="checkNumber($event)" (paste)="onPaste($event)">
                        </div>
                        <div class="mobile">
                            <input type="text" class="form-control" id="mobile" placeholder="Contact Number" 
                            formControlName="mobile" maxlength="10" (keydown)="checkNumber($event)" (paste)="onPaste($event)">
                        </div>
                        <div *ngIf="registrationForm.controls['countrycode']!.invalid || registrationForm.controls['mobile']!.invalid" class="errMsg">
                            <span *ngIf="isSubmitted || ((registrationForm.controls['countrycode']!.touched 
                            || registrationForm.controls['countrycode']!.dirty || registrationForm.controls['mobile']!.touched || 
                            registrationForm.controls['mobile']!.dirty) && 
                            ((registrationForm.controls['countrycode']!.errors && registrationForm.controls['countrycode']!.errors!['required']) || 
                            (registrationForm.controls['mobile']!.errors && registrationForm.controls['mobile']!.errors!['required'])))">Both fields are required</span>
                        </div>   
                    </div>
                    <div class="mb-4">
                        <img src="../../assets/images/email.png" alt="" >
                        <input type="email" class="form-control" id="email" placeholder="Email ID" formControlName="email">
                        <div *ngIf="registrationForm.controls['email']!.invalid" class="errMsg">
                            <span *ngIf="(isSubmitted || registrationForm.controls['email']!.touched || registrationForm.controls['email']!.dirty) && 
                            registrationForm.controls['email']!.errors!['required']">This field is required</span>
                           </div>    
                    </div>
                    <div class="mb-4">
                        <label class="emiratesLabel">
                            Emirates ID :
                        </label>
                        <div class="emiratesDiv">
                            <div>
                                <input type="text" class="form-control" id="emiratesId1" formControlName="emiratesId1" maxlength="3" minlength="3"
                                (keydown)="checkNumber($event)" (paste)="onPaste($event)">
                            </div>
                            <div class="emiratesDash">
                                <span>-</span>
                            </div>
                            <div>
                                <input type="text" class="form-control" id="emiratesId2" formControlName="emiratesId2" maxlength="4" minlength="4"
                                (keydown)="checkNumber($event)" (paste)="onPaste($event)">
                            </div>
                            <div class="emiratesDash">
                                <span>-</span>
                            </div>
                            <div>
                                <input type="text" class="form-control" id="emiratesId3" formControlName="emiratesId3" maxlength="7" minlength="7"
                                (keydown)="checkNumber($event)" (paste)="onPaste($event)">
                            </div>
                            <div class="emiratesDash">
                                <span>-</span>
                            </div>
                            <div>
                                <input type="text" class="form-control" id="emiratesId4" formControlName="emiratesId4" maxlength="1" minlength="1"
                                (keydown)="checkNumber($event)" (paste)="onPaste($event)">
                            </div>
                        </div>
                        
                        <div *ngIf="registrationForm.controls['emiratesId1']!.invalid || registrationForm.controls['emiratesId2']!.invalid || 
                        registrationForm.controls['emiratesId3']!.invalid || registrationForm.controls['emiratesId4']!.invalid" class="errMsg">
                            <span *ngIf="isSubmitted || ((registrationForm.controls['emiratesId1']!.touched 
                            || registrationForm.controls['emiratesId1']!.dirty || registrationForm.controls['emiratesId2']!.touched || 
                            registrationForm.controls['emiratesId2']!.dirty || registrationForm.controls['emiratesId3']!.touched 
                            || registrationForm.controls['emiratesId3']!.dirty || registrationForm.controls['emiratesId4']!.touched || 
                            registrationForm.controls['emiratesId4']!.dirty) && 
                            ((registrationForm.controls['emiratesId1']!.errors && registrationForm.controls['emiratesId1']!.errors!['required']) || 
                            (registrationForm.controls['emiratesId2']!.errors && registrationForm.controls['emiratesId2']!.errors!['required']) ||
                            (registrationForm.controls['emiratesId3']!.errors && registrationForm.controls['emiratesId3']!.errors!['required']) || 
                            (registrationForm.controls['emiratesId4']!.errors && registrationForm.controls['emiratesId4']!.errors!['required'])))">
                            Please enter valid format of Emirates ID</span>
                        </div>
                    </div>
                    <div class="mb-2">
                        <label class="passwordNote">Passwords must contain 8-15 characters and at least 1 number, 1 lowercase alphabet, 1 uppercase alphabet, 1 special character (All special characters can be used except ]  \  and spaces).</label>
                    </div>
                    <div class="mb-4">
                        <img src="../../assets/images/pass-avatar.png" alt="" >
                        <input type="text" class="form-control" id="password" placeholder="Password" formControlName="password" 
                        maxlength="15" required (keydown)="clearPasswordErr($event)" (paste)="onPaste($event)">
                        <div *ngIf="registrationForm.controls['password']!.invalid" class="errMsg">
                            <span *ngIf="(isSubmitted || registrationForm.controls['password']!.touched || registrationForm.controls['password']!.dirty) && 
                            (registrationForm.controls['password']!.errors && registrationForm.controls['password']!.errors!['required'])">This field is required</span>
                            <span *ngIf="isSubmitted &&  registrationForm.controls['password']!.errors && 
                            registrationForm.controls['password']!.errors!['pattern']">Please follow the valid pattern for password</span>
                        </div>
                    </div>
                    <div class="mb-4">
                        <img src="../../assets/images/pass-avatar.png" alt="" >
                        <input type="password" class="form-control" id="confirmPassword" placeholder="Confirm Password" 
                        formControlName="confirmPassword" required maxlength="15" (keydown)="clearPasswordErr($event)" (paste)="onPaste($event)">
                        <div *ngIf="registrationForm.controls['confirmPassword']!.invalid" class="errMsg">
                            <span *ngIf="(isSubmitted || registrationForm.controls['confirmPassword']!.touched || registrationForm.controls['confirmPassword']!.dirty) && 
                            (registrationForm.controls['confirmPassword']!.errors && registrationForm.controls['confirmPassword']!.errors!['required'])">This field is required</span>
                            <span *ngIf="(registrationForm.controls['confirmPassword']!.errors && !registrationForm.controls['confirmPassword']!.errors!['required']) && !passwordMatch">Your password and confirmation password do not match.</span>
                        </div>
                        <div *ngIf="registrationForm.controls['confirmPassword']!.valid" class="errMsg">
                            <span *ngIf="isSubmitted && !passwordMatch">Your password and confirmation password do not match</span>
                        </div>
                    </div>

                    <div class="mb-4" *ngIf="registrationErrResp" class="errMsg contactExistErr">
                        <span>{{registrationErrResp}}</span>
                    </div>
                    <div *ngIf="isRegistered">
                        <alert type="success" >
                            <p class="successAlert">Registration Successful. <a href="" class="clickHere">Click here</a> to Login.</p>
                        </alert>
                    </div>
                    <div class="row mt-5">
                        <div class="offset-8 col-lg-4">
                            <button type="button" class="w-100 btn btn-lg btn-primary" type="submit" (click)="registerUser()"
                            [disabled]="isAlreadyRegistered">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="footerDiv">
        <app-footer></app-footer>
    </div>
</ng-container>
<div *ngIf="!isOtpAuthenticated && !isAlreadyRegistered && loadOTPComponent">
    <app-otp-generation (verifyOtpEvent)="afterVerifiedOtpCheck($event)" [otpDetailsData]="otpDetails"></app-otp-generation>
</div>
<!-- <div *ngIf="!isOtpAuthenticated">
    <app-otp-generation (verifyOtpEvent)="afterVerifiedOtpCheck($event)"></app-otp-generation>
</div> -->



